import React, { useState, useEffect, useRef } from "react";
import styles from "./NavBar.module.css";
import { useRouter } from "next/router";
import { SubMenuProps } from "./NavBar.type";
import { activeClass } from "@/utils/helper";
import { removeStorage } from "@/utils/storage";
import { setCurrentStep, setPostAcademicInfo, setSchoolLogo, setSchoolName } from "@/redux/dataSlice";
import { useDispatch } from "react-redux";

const Menu = ({ menuData, sublink })  => {

  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ids, setId] = useState("");
  const [toggle, setToggle] = useState(null);
  const leaveTimeout = useRef<any>(null);  
  const router = useRouter();
  const dispatch = useDispatch();
  
  const handleMouseEnter = (id:any) => {
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
    }
    setDropdown(true);
    setId(id);
  };

  const handleMouseLeave = () => {
    leaveTimeout.current = setTimeout(() => {
      setDropdown(false);
      setId("");
    }, 200); 
  };

  useEffect(() => {
    const handleRouteChangeStart = () => {
      setLoading(true);
    };
    const handleRouteChangeComplete = () => {
      setLoading(false);
    };

    router.events.on("routeChangeStart", handleRouteChangeStart);
    router.events.on("routeChangeComplete", handleRouteChangeComplete);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  const handleClick = (e:any, href:string) => {
    e.preventDefault();
    setLoading(true);
    router.push(href);
  };

  const handleBack = (val:any) => {
    const name = val;
    setToggle(name);
  };

  const handleApplicationDirection=() =>{     
    removeStorage('currentStep');
    dispatch(setSchoolName(null));
    dispatch(setCurrentStep(0));
    dispatch(setPostAcademicInfo(null));
    dispatch(setSchoolLogo(null));
    router.push("application");
  };
  

  return (
    <ul className="navbar-nav me-auto  pt-lg-0 ps-lg-0 mb-2 mb-lg-0">
      {menuData?.map((menuItem, index) => (

        <li
          key={index}
          className={`nav-item ${
            menuItem?.submenu && menuItem?.submenu?.results?.length > 0
              ? "dropdown"
              : ""
          }
           ${menuItem?.submenu && menuItem?.submenu?.results?.length > 0 && toggle === menuItem.name && "active"}
          mr-40 `}
          onMouseEnter={() => handleMouseEnter(menuItem.name)}
          onMouseLeave={handleMouseLeave}
        >
          {menuItem?.submenu && menuItem?.submenu?.results?.length > 0 ? (
            <>
              <a
                className={`nav-link ${activeClass(router?.asPath, menuItem?.hyperlink, menuItem.name)} dropdown-toggle ${styles.navTxt}`}
                // href={menuItem.hyperlink || "#"}
                id={`navbarDropdown${index}`}
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onClick={() => handleBack(menuItem?.name)}
              >
                {menuItem?.name}
                {menuItem?.class && <span className={styles.dropdownArrow}>v</span>}

              </a>
              <SubMenu
                submenu={menuItem?.submenu?.results}
                handleMouseEnter={handleMouseEnter}
                handleMouseLeave={handleMouseLeave}
                dropdown={dropdown}
                ids={ids}
                // isMobileDevice={isMobileDevice}
                handleClick={handleClick}
                router={router}
                activeClass={activeClass}
                handleBack={handleBack}
                show={dropdown && ids === menuItem?.name}
              />
            </>
          ) : (
            <a
              className={`nav-link ${activeClass(router?.asPath, menuItem?.hyperlink)} ${styles.navTxt}`}
              onClick={(e) => handleClick(e, menuItem?.hyperlink || "#")}
              data-bs-toggle=""
              data-bs-target="#navbarTogglerDemo02"
              aria-controls="navbarTogglerDemo02"
            >


       {!sublink ? (
    <span 
    className={`${styles.link}`} 
    onClick={() => {
      if (menuItem?.name === "Applications") {
        handleApplicationDirection();
      }
    }}
    >{menuItem?.name}</span>
  ) : (
    <div className={`${styles.sublinkMain}`}>
    <span  className={`${styles.sublink}`}>{menuItem?.name}</span>
  </div>
  )}



            </a>
          )}
        </li>
      ))}
    </ul>
  );
};

const SubMenu = ({
  submenu,
  handleMouseEnter,
  handleMouseLeave,
  dropdown,
  ids,
  // isMobileDevice,
  handleClick,
  router,
  handleBack,
  show
}:SubMenuProps) => {
  return (
    <ul
      className={`dropdown-menu ${
        submenu?.length < 5 ? "dropdownmenu_l2" : ""
      }  `}
      aria-labelledby="navbarDropdown"
      onMouseEnter={() => handleMouseEnter(ids)}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="mobile-submenu-close justify-content-end"
        onClick={() => handleBack(null)}
      >
        <button
          className="navbar-toggler position-relative p-1 close"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
        </button>
      </div>
      {submenu.map((subItem, index) => (
        <li key={index}>
          {subItem?.hyperlink ? (
            <div
              className={`${styles.submenu_wp} main_menu_mobile`}
              onMouseEnter={() => handleMouseEnter(ids)}
              onMouseLeave={handleMouseLeave}
            >
              <button
                type="button"
                className="mobile-sub-back btn px-0 mt-3 mb-4"
                onClick={() => handleBack(subItem?.name)}
              >
                {" < "}
                <span>Back</span>
              </button>
              <a
                className={`dropdown-item ${
                  dropdown && ids === index && styles.menu_name_highlight
                } 
                ${activeClass(router?.asPath, subItem?.hyperlink)}  
                ${styles.left_side_lists}`}
                data-bs-toggle="collapse"
                data-bs-target="#navbarTogglerDemo02"
                aria-controls="navbarTogglerDemo02"
                onClick={(e) => handleClick(e, subItem?.hyperlink || "#")}
              >
                {subItem?.name}
                {subItem?.submenu?.results?.length > 0 && (
                  <span className={styles.navbar_arrow_icon}>{" > "}</span>
                )}
              </a>
              {subItem?.submenu?.results?.length > 0 && (
                <ul className={`${styles.level_menu} ${styles.right_side_list}`}>
                  {subItem?.submenu?.results?.map((item, subIndex) => (
                    <li key={subIndex} className="dropdown-item submenu_1">
                      <a
                        onClick={(e) => handleClick(e, item?.hyperlink || "#")}
                        className={`${styles.link_sub_item} `}
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarTogglerDemo02"
                        aria-controls="navbarTogglerDemo02"
                      >
                        {item?.name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ) : (
            <span className="dropdown-item">{subItem?.name}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default Menu;
